module.exports = __webpack_public_path__ + "img/logo-inline-white.3a43e748.webp";